// Copyright (c) 2016 Deere & Company

import {formatClaimNumber} from './format-claim-number';

export const buildClaimRoutes = (claimKey, subClaimKey, claimNumber) => {

    const formattedClaimNumber = formatClaimNumber(claimNumber);

    const key = claimKey === 'ZZMK' ?
        subClaimKey :
        claimKey;

    const map = {
        JDP: `/claims/jdp/edit/${formattedClaimNumber}`,
        MCC: `/claims/mcc-followup/edit/${formattedClaimNumber}`,
        MTC: `/claims/maintenance-plan/edit/${formattedClaimNumber}`,
        PDI: `/claims/mass-channel-pdi/edit/${formattedClaimNumber}`,
        PDP: `/claims/mass-channel-pdi/edit/${formattedClaimNumber}`,
        PMI: `/claims/incentive/edit/${formattedClaimNumber}`,
        WRP: `/claims/wear-parts/edit/${formattedClaimNumber}`,
        ZNRM: `/claims/normal/edit/${formattedClaimNumber}`,
        ZPAR: `/claims/parts/edit/${formattedClaimNumber}`,
        ZPIP: `/claims/pip/edit/${formattedClaimNumber}`,
        ZSPA: `/claims/spa/edit/${formattedClaimNumber}`,
        ZZBT: `/claims/battery/edit/${formattedClaimNumber}`,
        ZZNS: `/claims/attachment/edit/${formattedClaimNumber}`,
        ZZTK: `/claims/track/edit/${formattedClaimNumber}`
    };

    return map[key] || '';

};



// WEBPACK FOOTER //
// ./src/shared/services/build-claim-route.js